import { useCallback, useState, type ReactNode } from 'react';
import { ConfirmDialog } from '../components/Choices.js';

interface Ask {
  title: string;
  body: ReactNode;
  confirmLabel: string;
  danger?: boolean;
}

/**
 * An in-app replacement for `window.confirm` (F10): `ask()` resolves true when
 * the person confirms. Render `dialog` once in the component.
 */
export function useConfirm(): [ReactNode, (a: Ask) => Promise<boolean>] {
  const [req, setReq] = useState<{ ask: Ask; resolve: (ok: boolean) => void } | null>(null);
  const ask = useCallback((a: Ask) => new Promise<boolean>((resolve) => setReq({ ask: a, resolve })), []);
  const close = (ok: boolean) => {
    req?.resolve(ok);
    setReq(null);
  };
  const dialog = (
    <ConfirmDialog
      open={req !== null}
      title={req?.ask.title ?? ''}
      body={req?.ask.body}
      confirmLabel={req?.ask.confirmLabel ?? 'OK'}
      danger={req?.ask.danger}
      onCancel={() => close(false)}
      onConfirm={() => close(true)}
    />
  );
  return [dialog, ask];
}
